import DotEnv from '../env'

/**
 * Get the good file path for the json files
 * @param {String} file
 * @returns {String}
 */
export default file => ((DotEnv.decrypt('VUE_APP_ENC') === 'dev') ? `/json/local_${file}` : `/json/${file}`)
